export enum UserThemesEnum {
  LIGHT = 'light',
  DARK = 'dark',
  SYSTEM = 'system',
  DARK_SIDEBAR = 'darkSidebar',
}
